// 记录localStorage key，方便追踪
// 与原生共用的key请使用N-开头，例如“N-test1”

import commonChickenKey from 'root/promo/chicken/utils/localkey';

const keyConfig = {
    testKey: 'N-test1', // 测试key

    cartNumKey: 'N-cartNumber', //购物车数量
    locationChooseCity: 'N-locationChooseCity', //选择城市
    locationAutoToggleTime: 'N-locationAutoToggleTime', //自动切换时间

    selectCitySearchHistory: 'N-selectCitySearchHistory', // 搜索记录
    newTbAbTest: 'N-newTbAbTest',

    nearbyUiAbTest: 'nearbyUiAbTest', // 周边样式abtest
    locationDiffCacheTime: 'locationDiffCacheTime', //判断定位弹窗时间缓存兼容处理
    /**
     * 是否新用户
     */
    isNewUser: 'isNewUser',
    // 是否已经授权京东到家服务
    isJdServiceConfirmed: 'isJdServiceConfirmed',

    // 未读消息数目
    messageNotReadNum: 'N-messageNotReadNum',
    // 刷新页面
    movieRefreshPage: 'movieRefreshPage',
    // 获取数据出错后端同步数据倒计时
    movieSyncData: 'movieSyncData',
    // 电影票首页电影列表定位loading
    movieDisableLocateLoading: 'movieDisableLocateLoading',
    movieHomeTab: 'movieHomeTab',

    // 一键挂公告
    noticeBarContent: 'noticeBarContent',

    // 用户id
    userId: 'userId',
    memberId: 'member_id',
    //用户信息
    userInfo: 'user_info',

    // 返现显藏
    feedBackHidden: 'feedBackHidden',
    switchTab: 'switchTab',
    nearbyElemeABTest: 'nearbyElemeABTest',
    // 缓存「周边」数据
    nearByFilterData: 'nearByFilterData',
    nearByFilterCityId: 'nearByFilterCityId',
    nearByNoLocation: 'nearByNoLocation',
    // 周边默认tab
    nearByTabData: 'nearByTabData',
    // 禁用本地时间偏差修正
    disableTimeCorrection: 'disableTimeCorrection',
    // 禁用买单最低价格限制
    disableNearbyPayPriceLimit: 'disableNearbyPayPriceLimit',
    // 特权页ABtest标志
    privilegeABTest: 'privilegeABTest',

    notifyDialogSetting: 'notifyDialogSetting',
    // 周边abTest
    nearbyABTest: 'nearbyABTest',
    nearByTopAdShopIndex: 'nearByTopAdShopIndex',

    // 秒杀book的缓存（接口有30s缓存，为了避免刷新后状态变回去，所以前端做一层缓存）
    seckillBookCache: 'seckillBookCache',
    // 消息中心
    messageCenterPermission: 'messageCenterPermission',

    // 埋点页面数据记录 （12小时缓存）
    SessionLastPagePvargs: 'N-last-page-pvargs', // 记录上次pageView的相关数据
    SessionViewList: 'N-viewList', // 记录浏览href数组
    SessionObjList: 'N-objList', // 记录浏览数据map
    openReturnRedpacket: 'openReturnRedpacket', // 返现红包自动弹窗相关数据
    openReturnRedpacketOrderSn: 'openReturnRedpacketOrderSn', // 已经自动弹过窗的订单

    // 第三方特权输出
    privilegeSourceChannel: 'privilegeSourceChannel',
    // 第三方特权输出key
    privilegeSourceChannelSign: 'privilegeSourceChannelSign',

    reminderPageData: 'reminderPageData', // 定时组件缓存数据
    // 苏宁获取用户地址，传给接口，如果获取失败，则24小时后再获取
    getUserLocationFailFlag: 'getUserLocationFailFlag',

    shareCardRedirectUrl: 'shareCardRedirectUrl', // 分享电子卡链接
    shareDistributionRedirectUrl: 'shareDistributionRedirectUrl', // 全民分销链接
    closedShareCardWindow: 'closedShareCardWindow', // 是否手动点击支付成功后关闭弹窗
    lastShareOrderId: 'lastShareOrderId',
    paySuccessComment: 'paySuccessComment',
    orderSuccessShareType: 'orderSuccessShareType',
    shareCountDownStartTime: 'shareCountDownStartTime', // 支付成功弹窗倒计时

    // 标识是否从整点秒杀列表页跳转详情页的
    isFromHourSeckill: 'isFromHourSeckill',

    // 弹窗记录，次数，上次弹出时间等
    popupRecord: 'popupRecord',
    // 浮标记录，次数，上次弹出时间等
    iconShowRecord: 'iconShowRecord',
    // 页面点击关闭浮标的时间
    iconCloseTimeRecord: 'iconCloseTimeRecord',
    // 分享赚钱与更换主题图片页的传递参数
    shareMakeMoneyChangeThemeParams: 'shareMakeMoneyChangeThemeParams',
    // 用户的团长相关信息
    leaderInfo: 'leaderInfo',
    // ztm
    ztmConfig: 'ztmConfig',
    // 加油首页图片弹窗隐藏时效
    oilIndexPopupImgHide: 'oilIndexPopupImgHide',
    // 充电首页图片弹窗隐藏时效
    chargeIndexPopupImgHide: 'chargeIndexPopupImgHide',
    // 加油：用户选择过的油号
    USER_SELECTED_OIL: 'USER_SELECTED_OIL',
    refreshOilStationList: 'refreshOilStationList',
    backToOilHomePage: 'backToOilHomePage',

    // 搜索结果全部tab
    selectAllTabABTest: 'selectAllTabABTest',

    // 实名认证缓存
    USER_AUTHENTICATION_CACHE_KEY: 'USER_AUTHENTICATION_CACHE_KEY_v1.0',

    // 618运营-整点领红包，当天拿红包次数
    redPacketLocationCount: 'redPacketLocationCount',

    // 是否在优惠券列表页显示「什么是返现卡」
    isHideWhatIsDoubleCard: 'isHideWhatIsDoubleCard',

    tqPollOrderId: 'tqPollOrderId', // 特权轮询 orderId

    // 充值是否连续包月
    isCurrentPaymentCycle: 'isCurrentPaymentCycle',

    tqSecKillPayEndTime: 'tqSecKillPayEndTime',

    tqSecKillMeta: 'tqSecKillMeta',

    tqSecKillLimitedInfo: 'tqSecKillLimitedInfo',

    tqczCurrentSpuInfo: 'tqczCurrentSpuInfo',

    tqSecKillBackToIndexStep: 'tqSecKillBackToIndexStep',

    // 是否微信头像昵称授权
    isBindWx: 'isBindWx',
    // abtest
    abtest: 'abtest',
    // h5abtest
    h5Abtest: 'h5abtest',
    // 是否是炸鸡外卖
    isKfcTakeOut: 'isKfcTakeOut',
    // kfc外卖个人地址信息
    kfcOrderUserInfo: 'kfcOrderUserInfo',
    // kfc外卖菜单对比
    kfcDiffMenu: 'kfcDiffMenu',
    // kfc用户经纬度信息
    kfcUserPosition: 'kfcUserPosition',
    // kfc地址
    kfcAddressInfo: 'kfcAddressInfo',

    lastNativePagePvargs: 'N-last-native-page-pvargs',
    lastPagePvargs: 'N-last-h5-page-pvargs',
    lastPagePvargsOfGIO: 'N-last-h5-page-pvargs-of-gio',
    // 分享参数
    shareHash: 'shareHash',
    // 供应商id
    supplierId: 'supplierId',
    // 页面历史
    pageHistory: 'page-history',
    // 入口位置（用于需要变更入口位置，又不能改变全局入口信息时）
    privateEntrancePosition: 'privateEntrancePosition',
    // 入口页面（用于需要变更入口位置，又不能改变全局入口信息时）
    privateEntrancePage: 'privateEntrancePage',
    // 衡量有没有跳进授权页面
    isPddGotoAuth: 'isPddGotoAuth',
    // 商品类目缓存
    goodsTypeList: 'goodsTypeList',
    // 供应商
    supplierList: 'supplierList',
    // 是否上报过userId
    isSetUserId: 'isSetUserId',

    ...commonChickenKey, // 炸鸡聚合key

    dataQueue: 'dataQueue', // 传递数据队列
    // 降价订阅toast
    priceCutSubTips: 'priceCutSubTips',

    // 积分兑换单选框详情页是否勾选
    integralChecked: 'integralChecked',
    // 余额不足是否显示过积分组件
    showIntegral: 'showIntegral',
    // 积分注册前入口页面url
    lastIntegralSamePage: 'lastIntegralSamePage',
    // 积分注册页面url
    integralRegisterUrl: 'integralRegisterUrl',

    lastSamePageByAliVerify: 'lastSamePageByAliVerify',
    registerUrlByAliVerify: 'registerUrlByAliVerify',

    movieChooseCity: 'movie-choose-city',
    movieCurrentCity: 'movie-current-city',
    moviePositionCity: 'movie-position-city',
    movieHasLocation: 'movie-has-location',
    movieSeatList: 'movie-seat-list',
    movieSelectCitySearchHistory: 'movie-select-city-history',
    energySelectPopupTime: 'energySelectPopupTime',
    energySelect: 'energySelect',
};

export const keys = Object.values(keyConfig);

export default keyConfig;
